export enum Meal {
	BREAKFAST = 'BREAKFAST',
	FULL_BOARD = 'FULL_BOARD',
	GLUTEN_FREE = 'GLUTEN_FREE',
	HALF_BOARD = 'HALF_BOARD',
	SELF_CATERING = 'SELF_CATERING',
	SPECIAL_MENU = 'SPECIAL_MENU',
}

export const MEALS = [Meal.BREAKFAST, Meal.HALF_BOARD, Meal.FULL_BOARD, Meal.SELF_CATERING, Meal.GLUTEN_FREE, Meal.SPECIAL_MENU];

export const MEALS_IVVA = [Meal.BREAKFAST, Meal.HALF_BOARD, Meal.FULL_BOARD, Meal.SELF_CATERING];
